<script setup>
// SiteUp: item "Sugerir resposta" do agente Captain DENTRO do menu ✨ do editor,
// no MESMO padrão visual dos itens nativos (componente Button slate/link/sm +
// ícone i-fluent-*), pra não destoar. O STATUS (IA ativa/pausada) e o toggle
// (pausar/devolver) foram movidos pra BARRA do editor (AiAgentBadge), visíveis sem
// abrir o menu. Só renderiza nos perfis que oferecem sugestão (suggest_manual /
// suggest_auto / autonomous_suggest); em "Autônoma" pura, "Desligada" ou contas
// sem agente, nada aparece.
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { emitter } from 'shared/helpers/mitt';
import Button from 'dashboard/components-next/button/Button.vue';
import { canSuggestForChat } from 'dashboard/helper/aiAgentMode';

const emit = defineEmits(['close']);

const currentChat = useMapGetter('getSelectedChat');

// Gating: o "Sugerir resposta" só aparece nos perfis que oferecem sugestão
// (suggest_manual / suggest_auto / autonomous_suggest). "Autônoma" pura e
// "Desligada" não mostram nada.
const enabled = computed(() => canSuggestForChat(currentChat.value));
const conversationId = computed(() => currentChat.value?.id);

// SiteUp: só dispara a geração; quem gera é o ReplyBox (loading no painel do copilot,
// igual ao Resumir). Fecha o menu na hora — a requisição não fica presa aqui.
const suggest = () => {
  if (!conversationId.value) return;
  emitter.emit('aiAgentGenerateSuggestion');
  emit('close');
};

defineExpose({ enabled });
</script>

<template>
  <Button
    v-if="enabled"
    label="Sugerir resposta"
    icon="i-fluent-chat-sparkle-16-regular"
    slate
    link
    sm
    class="hover:!no-underline text-n-slate-12 font-normal text-xs w-full !justify-start"
    @click="suggest"
  />
</template>
